module.exports = __webpack_public_path__ + "static/media/rome-13.e7ae7302.jpg";